import { ForwardedRef, forwardRef } from "react";
import { CardImgTitleInterface } from "../../../interfaces/CardWithImgAndTitlesInterface";
import { CardImgTitle } from "./CardWithImgAndTitleStyles";
import { motion } from "framer-motion";

export const CardWithImgAndTitle = forwardRef(
  (
    { img, title, width }: CardImgTitleInterface,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <CardImgTitle ref={ref} style={{ width: `${width}` }}>
        <img src={img} alt="" />
        <h5>{title}</h5>
      </CardImgTitle>
    );
  }
);

export const MCardWithImgAndTitle = motion.create(CardWithImgAndTitle);
